import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { AccountStatusNotice } from './AccountStatusNotice';

export function ProtectedRoute({ children, requiredRoles = null, requiredPermission = null }) {
  const { user, userRole, loading, accountStatus } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!userRole) {
    return <AccountStatusNotice variant={accountStatus} />;
  }

  if (requiredRoles && !requiredRoles.includes(userRole.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredPermission && !(userRole.permissions || []).includes(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
